module.exports = __webpack_public_path__ + "img/yardages.0c88fa0f.svg";